export default __webpack_public_path__ + "static/media/home2.c0f283c4.jpg";